"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = isBlank;
var _isBlank = _interopRequireDefault(require("is-blank"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function isBlank(object) {
  if (object === true || object === false || object === 0) {
    return false;
  }
  if (typeof object === 'string') {
    if (object.length === 0) {
      return true;
    }
    if (object.trim().length > 0) {
      return false;
    }
  }
  return (0, _isBlank["default"])(object);
}
;